var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E4E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7652 6.23504C14.5762 3.04606 9.40912 3.04093 6.22631 6.22374C3.04144 9.40963 3.04452 14.5746 6.23555 17.7636C9.42452 20.9526 14.5926 20.9567 17.7744 17.7739C20.9582 14.5911 20.9552 9.42401 17.7652 6.23504ZM13.6539 15.4312L11.9202 13.6975L10.1866 15.4312C9.47896 16.1388 8.94695 16.7551 8.10272 15.9119C7.26054 15.0686 7.87369 14.5366 8.5844 13.828L10.3181 12.0954L8.5844 10.3617C7.87574 9.65407 7.26054 9.12206 8.10272 8.27783C8.94695 7.43565 9.47896 8.05085 10.1866 8.75951L11.9202 10.4911L13.6539 8.75951C14.3626 8.05188 14.8915 7.43463 15.7357 8.27783C16.5799 9.12206 15.9647 9.65407 15.2561 10.3617L13.5224 12.0943L15.2561 13.827C15.9637 14.5366 16.5799 15.0686 15.7357 15.9119C14.8935 16.7551 14.3626 16.1388 13.6539 15.4312Z",
    fill: "#EC4C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConfirmed);
export default __webpack_public_path__ + "static/media/notConfirmed.79fe01845943376a3d62e0bb9039e537.svg";
export { ForwardRef as ReactComponent };